import { render } from "./animals_report.vue?vue&type=template&id=5d964ee5"
import script from "./animals_report.vue?vue&type=script&lang=js"
export * from "./animals_report.vue?vue&type=script&lang=js"

import "./animals_report.vue?vue&type=style&index=0&id=5d964ee5&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__